import { useMobile } from '~/hooks/responsive'

import { IS_BOAT } from '~/brands'

export const possibilityConfig = [
  { maxWidthText: 200, text: 'Update your ad as often as you like.' },
  { text: 'Reach premium online buyers.' },
  { text: 'One flat fee until sold, independent of your sale price.' }
]

export const sellingEasyConfig = () => {
  const isMobile = useMobile()

  return [
    {
      text:
        'Simply click start and follow the onscreen prompts to enter details about your boat. Use the "Continue" button to progress.',
      color: IS_BOAT ? '#28A2BF' : '#2896DE',
      height: isMobile ? 135 : 100
    },
    {
      text:
        'Each package allows for the publication of one listing, which will remain active on the platform until sold.',
      color: IS_BOAT ? '#2C95B7' : '#2C8BD1',
      height: isMobile ? 160 : 135
    },
    {
      text:
        'You can save your listing as a draft at any point during the creation process. The pre-filled data will be saved in your profile, allowing you to continue the creation flow from the step at which it was saved as a draft.',
      color: IS_BOAT ? '#2E8DB3' : '#2F83C7',
      height: isMobile ? 125 : 110
    },
    {
      text: 'Upload at least three images.',
      color: IS_BOAT ? '#3086AF' : '#327BBD',
      height: 100
    },
    {
      text:
        'If there are youtube videos for your product, copy and paste the video link once prompted.',
      color: IS_BOAT ? '#337EAA' : '#3475B6',
      height: 100
    },
    {
      text: 'You can choose upgrades to make your AD stand out from the rest.',
      color: IS_BOAT ? '#3675A5' : '#376EAE',
      height: isMobile ? 120 : 100
    },
    {
      text: 'Pay for your advertising package using a credit card.',
      color: IS_BOAT ? '#396A9F' : '#3967A5',
      height: isMobile ? 125 : 110,
      helperText:
        '(Your listing will be saved as a draft while you enter your payment details.)'
    },
    {
      text:
        'Once payment is confirmed, we will check your listing details and approve it for sale.',
      color: '#3D5B97'
    }
  ]
}
